import { render, staticRenderFns } from "./InvoiceInquiryPage.vue?vue&type=template&id=23945cb1&scoped=true&"
import script from "./InvoiceInquiryPage.vue?vue&type=script&lang=js&"
export * from "./InvoiceInquiryPage.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceInquiryPage.vue?vue&type=style&index=0&id=23945cb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23945cb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23945cb1')) {
      api.createRecord('23945cb1', component.options)
    } else {
      api.reload('23945cb1', component.options)
    }
    module.hot.accept("./InvoiceInquiryPage.vue?vue&type=template&id=23945cb1&scoped=true&", function () {
      api.rerender('23945cb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/invoice/invoiceInquiry/InvoiceInquiryPage.vue"
export default component.exports